import React, { useState, useEffect } from 'react'
import { Steps } from 'antd'
import { Outlet, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import Step1Page from './ProfileDetails'
import Step2Page from './OrganizationDetails'
import Step3Page from './LegalInformation'
import { uniqueId } from 'lodash'

const { Step } = Steps

const stepRoutes = ['personal-details', 'organization-details', 'legal-information']

const stepTitles = ['Personal Details', 'Organization Details', 'Legal Information']

const NewClientPage = () => {
  const [currentStep, setCurrentStep] = useState(0)
  const location = useLocation()
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    organization: '',
    location: null,
    companySize: '',
    industry: '',
    logo: null,
    registeredAddress: '',
    typeOfCompany: '',
    dateOfIncorporation: '',
    businessContactNumber: '',
    CIN: '',
    PAN: '',
    TAN: '',
    GSTIN: ''
  })

  useEffect(() => {
    const currentStepIndex = stepRoutes.findIndex((stepRoute) =>
      location.pathname.includes(stepRoute)
    )

    if (currentStepIndex !== -1) {
      setCurrentStep(currentStepIndex)
    }
  }, [location.pathname])

  return (
    <>
      <div className='w-50 mx-auto mt-2 p-4'>
        <h2 className='text-center mb-8'>Onboarding Process</h2>
        <Steps current={currentStep}>
          {stepTitles.map((title, index) => (
            <Step
              key={uniqueId()}
              title={title}
              disabled={index !== currentStep}
              onClick={() => {
                if (index === currentStep) {
                  navigate(stepRoutes[index])
                }
              }}
            />
          ))}
        </Steps>
        {/* <Step1Page/> */}
      </div>
      <Routes>
        <Route element={<Outlet />}>
          <Route
            path='personal-details'
            element={<Step1Page formData={formData} setFormData={setFormData} />}
          />
          <Route
            path='organization-details'
            element={<Step2Page formData={formData} setFormData={setFormData} />}
          />
          <Route
            path='legal-information'
            element={<Step3Page formData={formData} setFormData={setFormData} />}
          />
        </Route>
        <Route index element={<Step1Page formData={formData} setFormData={setFormData} />} />
      </Routes>
    </>
  )
}

export default NewClientPage
